import { Button, Grid } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker, LocalizationProvider, MobileTimePicker } from '@mui/x-date-pickers';
import { useTranslation } from "react-i18next";
import { useSearchOptions } from "../../../providers/SearchOptions";
import AppSelect from "../../AppSelect/AppSelect";
import "./AddExceptions.scss";
import dayjs from "dayjs";
import { matTimePickerStyle } from "../../../assets/style/material/matSyles";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useRef, useState } from "react";

export default function AddExceptions({
  selects,
  index,
  exceptions,
  setExceptions,
}) {
  const { t } = useTranslation();
  const { equipmentOptions, positionOptions, baseOptions } = useSearchOptions();
  const exception = exceptions[index];
  const settings = exception.settings;
  const selectedDates = exception.selectedDates;
  const timepickerStyle = matTimePickerStyle();
  const ref = useRef<HTMLInputElement>(null);
  const [className, setClassName] = useState('pointer-selected');
  const [mode, setMode] = useState('hours');


  const removeException = (index) => {
    setExceptions(exceptions.filter((_, i) => i !== index));
  };

  const handleDateChange = (name, date) => {
    exceptions[index].selectedDates = { ...selectedDates, [name]: date };
    setExceptions([...exceptions]);
  };

  const formatDate = (value) => new Date(dayjs(value).format("YYYY/MM/DD"))

  const formatTime = (value) => {
    const time = new Date();
    time.setHours(dayjs(value).hour());
    time.setMinutes(dayjs(value).minute());
    return time;
  }

  const handlePointer = (value) => setClassName((mode === 'hours' || Number(dayjs(value).format("mm")) % 5 === 0) ? 'pointer-selected' : '');

  return (
    <>
      {index === 0 ? (
        <h3>Add an exception</h3>
      ) : (
        <>
          <h3>Exception #{index + 1}</h3>
          <Button
            variant="outlined"
            className="remove-btn btn"
            onClick={() => removeException(index)}
          >
            {t('Admin.remove')}
          </Button>
        </>
      )}
      <h4>Change is for:</h4>
      <div className="select-zone">
        <AppSelect
          key={`baseAirport-${index}`}
          selectLabel={t('Admin.base')}
          fillElements={baseOptions}
          selectRef={selects}
          selectedItem={settings.baseAirport}
          multiSelect={false}
          name={`baseAirport-${index}`}
        />
        <AppSelect
          key={`equipment-${index}`}
          selectLabel={t('Admin.equipment')}
          fillElements={equipmentOptions}
          selectRef={selects}
          selectedItem={settings.equipment}
          multiSelect={false}
          name={`equipment-${index}`}
        />
        <AppSelect
          key={`position-${index}`}
          selectLabel={t('Admin.rank')}
          fillElements={positionOptions}
          selectRef={selects}
          selectedItem={settings.position}
          multiSelect={false}
          name={`position-${index}`}
        />
      </div>
      <h4 style={{ marginBottom: 20}}>Enter date and time changes:</h4>
      <div className="date-zone" style={{ marginBottom: 20 }}>
        <Grid container justifyContent="flex-start">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              key={`post-date-${index}`}
              format="DD MMM, YYYY"
              label={t('Admin.publish.date')}
              value={dayjs(new Date(selectedDates.pairingPostedOn ?? ''))}
              onChange={(value) => handleDateChange('pairingPostedOn', formatDate(value))}
            />
            <DatePicker
              key={`close-date-${index}`}
              format="DD MMM, YYYY"
              label={t('Admin.close.date')}
              value={dayjs(new Date(selectedDates.biddingClosedOn ?? ''))}
              onChange={(value) => handleDateChange('biddingClosedOn', formatDate(value))}
            />

            <MobileTimePicker
              key={`close-time-${index}`}
              label={t('Admin.close.time')}
              value={dayjs(new Date(selectedDates.blockCloseTime ?? ''))}
              onChange={(value) => { handleDateChange('blockCloseTime', formatTime(value)); handlePointer(value); }} 
              slotProps={{ layout: { className: `${timepickerStyle.root} timepicker ${className}` }, leftArrowIcon: { style: { display: 'none'}}, rightArrowIcon: { style: { display: 'none'}}}}
              inputRef={ref}
              onViewChange={(value) => { setMode(value); setClassName(value === 'hours' ? 'pointer-selected' : '');}}
            />
            <div className="time-icon-container">
              <AccessTimeIcon className="time-icon" onClick={() => { ref.current?.click(); }} />
            </div>
          </LocalizationProvider>
        </Grid>
      </div>
      <hr />
    </>
  );
}


